import type { Lighting_LuminaireMaintenanceDetailsModel } from "src/graphql/types";

export const maintenanceDetailsDefaultValues: Lighting_LuminaireMaintenanceDetailsModel =
  {
    qualifiedForReplacement: false,
    owner: null as any,
  };
